<template>
  <v-container max-width="1200" class="pa-4">
    <v-row justify="space-between">
      <v-col cols="8" sm="10">
        <span style="font-size: 26pt">{{ $t('label.portalEdi') }}</span>
        <br>
        <h4 class="primary--text">{{ $t('label.home') }}</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(app, i) in getAllSections" :key="i" cols="6" sm="6" md="4" lg="3">
        <v-hover v-if="(app.name == 'consignment' && userInfo.isConsignment) || app.name != 'consignment'">
          <template v-slot:default="{ hover }">
            <v-card
              color="#00469C"
              :href="app.href ? baseUrl + app.href : undefined"
              :target="app.href ? '_blank' : undefined"
              :rel="app.href ? 'noopener' : undefined"
              @click.stop="routeTo(app)"
            >
              <v-card-text>
                <v-row justify="center">
                  <v-icon color="white" size="110">{{ app.icon }}</v-icon>
                </v-row>
                <v-row justify="center">
                  <label class="white--text">{{ $t(app.display) }}</label>
                </v-row>
              </v-card-text>
              <v-fade-transition>
                <v-overlay
                  v-if="hover"
                  absolute
                  color="#036358"
                >
                  <v-btn
                    :href="app.href ? baseUrl + app.href : undefined"
                    :target="app.href ? '_blank' : undefined"
                    @click.stop="routeTo(app)"
                  >{{ $t(app.display) }}</v-btn>
                </v-overlay>
              </v-fade-transition>
              </v-card>
          </template>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { userInfo } from '../mixins'
import menuOptions from '../utils/menuOptions'
export default {
  name: 'HomePage',
  mixins: [userInfo],
  data: () => ({
    baseUrl: process.env.BASE_URL
  }),
  computed: {
    moduleApps () {
      return [
        { name: this.$t('label.auctions'), route: 'openAuctions', icon: 'mdi-clipboard-list', buttonText: this.$t('label.goToAuctions'), module: 'auctions' },
        { name: this.$t('label.purchaseOrders'), route: 'purchaseOrders', icon: 'mdi-receipt', buttonText: this.$t('label.goToPurchaseOrders'), module: 'purchaseOrders' },
        { name: this.$t('label.portalEdi'), route: 'ediReleases', icon: 'mdi-view-dashboard', buttonText: this.$t('label.goToPortalEdi'), module: 'edi' }
      ]
    },
    accesibleApps () {
      if (this.userInfo.apps) {
        return this.moduleApps.filter(m => this.userInfo.apps.findIndex(r => r.code === m.module) > -1)
      } else {
        return []
      }
    },
    getUserSection () {
      return menuOptions.getUserSection()
    },
    getShipmentSection () {
      return menuOptions.getShipmentSection()
    },
    getAllSections () {
      return menuOptions.getAllSections()
    }
  },
  methods: {
    routeTo (app) {
      if (app.href) { return } // el href del elemento navega solo
      const route = typeof app === 'string' ? app : app.name
      if (this.$route.name !== route) {
        this.$router.push({ name: route })
      }
    }
  }
}
</script>

<style>

</style>
